// const mapToOptions = (items: any[]) =>
//   items.reduce(
//     (acc: Record<string, string>, { _id, name }: { _id: string; name: string }) => {
//       acc[_id] = name;
//       return acc;
//     },
//     {}
//   );

// export const addOptionsToFilters = (
//   filtersConfig: { evidence: Record<string, any>; idea: Record<string, any> },
//   context: { [key: string]: any[] }
// ) => {
//   const updatedFiltersConfig = { ...filtersConfig };
//   // Iterate through both `evidence` and `idea` filters
//   //@ts-ignore
//   ['evidence', 'idea'].forEach((filterType: 'evidence' | 'idea') => {
//     updatedFiltersConfig[filterType] && Object.values(updatedFiltersConfig?.[filterType]).forEach((filter: any) => {
//       if (filter.optionsKeyAppContext && context[filter.optionsKeyAppContext]) {
//         const options = mapToOptions(context[filter.optionsKeyAppContext]);
//         console.log("addOptionsToFilters", {options, context})
//         console.log('addOptionsToFilters options', options, filter);
//         filter.options = options;
//       }
//     });
//   });

//   return updatedFiltersConfig;
// };
import { slugify } from "../components/ideaNiv/helpers/calculateImpactResults";

const mapToOptions = (items: any[]) =>
  items.reduce((acc: Record<string, string>, item: any) => {
    // Handle both object with `_id`/`name` and simple strings
    if (typeof item === "object" && item._id && item.name) {
      acc[item._id] = item.name;
    } else if (typeof item === "string") {
      acc[item] = item;
    }
    return acc;
  }, {});

/** Uncategorized tags only for the aggregate `tagsOptions` key (not per-category `tag.*` keys). */
function getOptionsSourceForKey(optionsKey: string, rawOptions: any[]): any[] {
  return optionsKey === "tagsOptions" && !optionsKey.startsWith("tag.")
    ? rawOptions.filter((c: any) => c.categoryId == null)
    : rawOptions;
}

export const addOptionsToFilters = (
  filtersConfig: { evidence: Record<string, any>; idea: Record<string, any> },
  context: { [key: string]: any[] }
) => {
  const updatedFiltersConfig = { ...filtersConfig };
  //@ts-ignore
  ["evidence", "idea"].forEach((filterType: "evidence" | "idea") => {
    if (updatedFiltersConfig[filterType]) {
      Object.values(updatedFiltersConfig[filterType]).forEach((filter: any) => {
        const optionsKey = filter.optionsKeyAppContext;

        // console.log("Checking filter:", { filterType, optionsKey, context });

        // Check if `optionsKey` exists in context and has items
        if (optionsKey && context[optionsKey]?.length) {
          // console.log("Found matching options:", {
          //   optionsKey,
          //   options: context[optionsKey],
          // });
          const rawOptions = context[optionsKey];
          const optionsSource = getOptionsSourceForKey(optionsKey, rawOptions);
          const options =
          ["components", "owners", "members", "tagsOptions", "devTeams"].includes(optionsKey)?
            optionsSource.map((c:any) => ({
              ...c,
              label: c.name || c.label,
              value: c._id || c.value,
              childComponents: c?.childComponents?.map((cc:any) => ({
                ...cc,
                label: cc.name,
                value: cc._id,
              })),
            }))
            : mapToOptions(optionsSource);
          // console.log("Prepared options:", options);

          filter.options = options;
        } else if( optionsKey && optionsKey.startsWith("tag.") && context["tagsOptions"]?.length ) {
          let tagOptions: any[] = [];
          const categoryName = optionsKey.split(".")[1];
          // Use tagsOptions from context and filter by category.name
          if (context["tagsOptions"]?.length && categoryName) {
            if (categoryName.toUpperCase() === "DEFAULT") {
              tagOptions = context["tagsOptions"].filter(
                (tagsOption: any) => !tagsOption.category?.name
              );
            } else {
              tagOptions = context["tagsOptions"].filter(
                (tagsOption: any) => tagsOption.category?.name && slugify(tagsOption.category.name) === slugify(categoryName)
              );
            }
            tagOptions = tagOptions.map((c:any) => ({
              ...c,
              label: c.name || c.label,
              value: c._id || c.value,
              childComponents: c?.childComponents?.map((cc:any) => ({
                ...cc,
                label: cc.name,
                value: cc._id,
              })),
            }))
          }
          filter.options = tagOptions;
          // console.log("No relevant options found for:", optionsKey);
        } else if (optionsKey === "release") {
          /**
           * The ideas-list release filter is registered as `customizations`
           * data with `optionsKeyAppContext: 'release'`, which means the
           * option list comes from app context — the same arrangement the
           * `tag.` branch above uses, and for the same reason: the stored
           * values are **ObjectId strings**, so without this the filter would
           * offer raw hex to pick from.
           *
           * `context.releases` is already the flat, group-annotated shape
           * (`buildReleaseOptions`), so nothing is reshaped here beyond
           * defaulting to an empty list while the releases query is in
           * flight. `selectedIsObjId: true` on the registration is what makes
           * the backend build an `$in` over ObjectIds instead of a regex —
           * that key is the backend's, and it travels untouched through
           * `findFiltersByPath`.
           */
          filter.options = context["releases"] || [];
        }
      });
    }
  });

  return updatedFiltersConfig;
};

export const addOptionsToC360Filters = (
  c360FiltersConfig: Record<string, any>,
  context: { [key: string]: any[] }
) => {
  const updatedFiltersConfig = { ...c360FiltersConfig };
  
  // Iterate through all filters in the flat C360 structure
  Object.values(updatedFiltersConfig).forEach((filter: any) => {
    const optionsKey = filter.optionsKeyAppContext;

    // Check if `optionsKey` exists in context and has items
    if (optionsKey && context[optionsKey]?.length) {
      const optionsSource = getOptionsSourceForKey(optionsKey, context[optionsKey]);
      const options =
        ["components", "owners", "members", "tagsOptions", "devTeams"].includes(optionsKey)
          ? optionsSource.map((c: any) => ({
            ...c,
            label: c.name || c.label,
            value: c._id || c.value,
            childComponents: c?.childComponents?.map((cc: any) => ({
              ...cc,
              label: cc.name,
              value: cc._id,
            })),
          }))
          : mapToOptions(optionsSource);

      filter.options = options;
    } else if( optionsKey && optionsKey.startsWith("tag.") && context["tagsOptions"]?.length ) {
      let tagOptions: any[] = [];
      const categoryName = optionsKey.split(".")[1];
      // Use tagsOptions from context and filter by category.name
      if (context["tagsOptions"]?.length && categoryName) {
        if (categoryName.toUpperCase() === "DEFAULT") {
          tagOptions = context["tagsOptions"].filter(
            (tagsOption: any) => !tagsOption.category?.name
          );
        } else {
          tagOptions = context["tagsOptions"].filter(
            (tagsOption: any) => tagsOption.category?.name && slugify(tagsOption.category.name) === slugify(categoryName)
          );
        }
        tagOptions = tagOptions.map((c:any) => ({
          ...c,
          label: c.name || c.label,
          value: c._id || c.value,
          childComponents: c?.childComponents?.map((cc:any) => ({
            ...cc,
            label: cc.name,
            value: cc._id,
          })),
        }))
      }
      filter.options = tagOptions;
    }

    // Recursively process child filters if they exist
    if (filter.childFilters && Object.keys(filter.childFilters).length > 0) {
      Object.values(filter.childFilters).forEach((childFilter: any) => {
        const childOptionsKey = childFilter.optionsKeyAppContext;
        if (childOptionsKey && context[childOptionsKey]?.length) {
          const childOptionsSource = getOptionsSourceForKey(childOptionsKey, context[childOptionsKey]);
          const childOptions =
            ["components", "owners", "members", "tagsOptions", "devTeams"].includes(childOptionsKey)
              ? childOptionsSource.map((c: any) => ({
                ...c,
                label: c.name || c.label,
                value: c._id || c.value,
                childComponents: c?.childComponents?.map((cc: any) => ({
                  ...cc,
                  label: cc.name,
                  value: cc._id,
                })),
              }))
              : mapToOptions(childOptionsSource);

          childFilter.options = childOptions;
        }
      });
    }
  });

  return updatedFiltersConfig;
};

export const findFilterByName = (
  targetName: string,
  filterObject: "evidence" | "idea" | "all",
  ideasFiltersConfig: any
) => {
  const filtersList: any[] = [];

  if (filterObject == "all") {
    const evidenceFilters = ideasFiltersConfig["evidence"];
    const ideaFilters = ideasFiltersConfig["idea"];
    if (!evidenceFilters && !ideaFilters) return null;
    if (evidenceFilters) filtersList.push(evidenceFilters);
    if (ideaFilters) filtersList.push(ideaFilters);
  } else {
    const filters = ideasFiltersConfig[filterObject];
    if (!filters) return null;
    filtersList.push(filters);
  }

  const findRecursively = (obj: any): any => {
    for (const key in obj) {
      const filter = obj[key];
      if (filter.name?.toLowerCase() === targetName?.toLowerCase()) {
        const cleanedDbFieldPath = filter.dbFieldPath
          ?.replace("relatedRequests.", "")
          ?.replace("connectedOrgs", "company");
        return {
          ...filter,
          dbFieldPath: cleanedDbFieldPath,
        };
      }

      if (filter.childFilters) {
        const childResult = findRecursively(filter.childFilters);
        if (childResult) return childResult;
      }
    }
    return null;
  };

  for (const filters of filtersList) {
    const result = findRecursively(filters);
    if (result) return result;
  }

  return null;
};

export function findFiltersByPath(obj: any, path: string): any {
  const pathSegments = path.split('.');
  let currentObj = obj;


  for (const segment of pathSegments) {
    if (!currentObj) {
      console.log(`Path segment "${segment}" not found: currentObj is null`);
      return null; // Path not found
    }

    // If the segment matches the `name` property
    if (currentObj.name === segment) {
      continue; // Move to the next path segment
    }

    // Traverse directly if the key exists
    if (currentObj[segment]) {
      currentObj = currentObj[segment];
    }
    // Traverse into `childFilters` and find by `name`
    else if (currentObj.childFilters) {
      const found = Object.values(currentObj.childFilters).find(
        (child: any) => child.name === segment
      );
      if (found) {
        currentObj = found;
      } else {
        console.log(`Segment "${segment}" not found in childFilters`);
        return null; 
      }
    } else {
      console.log(`Segment "${segment}" not found in current object`);
      return null;
    }
  }

  return currentObj;
}

export const truncateTitle = (title: string, maxLength = 25) => {
  if (!title) return "";
  return title.length > maxLength ? `${title.substring(0, maxLength)}...` : title;
};

export const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}